import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
const resources = {
    ru: {
        translation: {
            header: { botSub: 'бот' },
            common: {
                cancel: 'Отмена',
                close: 'Закрыть',
                delete: 'Удалить',
                loading: 'Загрузка…',
                save: 'Сохранить',
                saving: 'Сохраняю…',
            },
            preset: {
                makeFromPhoto: 'Сделать пресет',
                makeFromPhotoTitle: 'Сделать пресет из кадра',
                drafting: 'AI собирает концепт…',
                draftUsedVision: 'AI учёл и саму картинку, и промпт',
                draftTierGate: 'Доступно на тарифе Pro',
                draftQuota: 'Лимит на сегодня исчерпан, попробуй завтра',
                draftError: 'Не удалось собрать концепт',
                concept: 'Концепт (промпт стиля)',
                conceptPh: 'стиль кадра без конкретного продукта',
                create: 'Создать пресет',
                created: 'Пресет создан',
                createError: 'Не удалось создать пресет',
                nameTaken: 'Пресет с таким именем уже есть',
            },
            batch: {
                title: 'Пакетная обработка',
                ctaHint: 'до 10 кадров по пресету',
                hint: 'Каждое фото/предмет = СВОЯ отдельная генерация по промпту пресета (не один кадр со всеми рефами). До 10 за раз — пойдут пачкой.',
                needPreset: 'Сначала выбери пресет — пакет генерит по его промпту',
                needRefs: 'Прикрепи фото — каждое станет отдельным кадром',
                switchHint: 'Пакет: сколько фото прикрепишь — столько кадров по пресету',
                composerHint: '📦 Пакет: каждое фото = свой кадр по пресету «{{name}}». Сейчас фото: {{n}}',
                modePhoto: 'Фото-рефы',
                modeText: 'Список предметов',
                refsLabel: 'Фото',
                photoNote: 'Каждое фото перекрашивается под концепт пресета — модель пресета должна уметь рефы.',
                subjectsLabel: 'Предметы — по одному на строку',
                run: 'Создать {{n}} кадров',
                started: 'Запущено кадров: {{n}}',
                uploadError: 'Не удалось загрузить фото',
                noCredits: 'Недостаточно кредитов',
                error: 'Не удалось запустить пакет',
            },
            home: {
                title: 'Scenix',
                plan_trial: 'Тариф: Trial',
                plan_tier10: 'Тариф: Light',
                plan_tier20: 'Тариф: Pro',
                balance: 'Бесплатных осталось: {{remaining}}/10',
                total: 'Всего сгенерировано: {{count}}',
                upgrade: 'Прокачать тариф',
            },
            tabs: {
                chat: 'Чат',
                home: 'Главная',
                history: 'История',
                ideas: 'Идеи',
                library: 'Библиотека',
                marketing: 'SMM‑щик',
                profile: 'Профиль',
                styles: 'Стили',
                settings: 'Настройки',
                studio: 'Студия',
                avatars: 'Аватары',
                skills: 'Скилы',
            },
            mode: {
                label: 'Режим',
                chat: 'Чат',
                studio: 'Студия',
                studioHint: 'Студия · холсты, AI-режиссёр (beta)',
            },
            chat: {
                recentTitle: 'Недавние генерации',
                recentEmpty: 'Здесь появятся ваши работы',
                tileSize: 'Размер плиток',
                tilesPerRow: 'В ряд',
                batchHint: 'Сколько кадров за раз: ×2 — Light, ×4 — Pro',
                greeting: 'Привет! Выберите модель ниже, прикрепите референс (опц.) и отправьте промпт.',
                aiGreeting: 'Привет! Я AI-ассистент. Опиши что хочется — соберу промпт и выберу модель сам.',
                generating: 'Генерирую',
                copy: 'Копировать',
                open: 'Открыть',
                repeat: 'Повторить',
                download: 'Скачать',
                aiThinking: 'AI думает...',
                aiQueueSuffix: 'в очереди',
                aiToggle: 'AI ассистент',
                aiModelByItself: 'модель выбирает AI',
                // Бар композера (единый вид с Главной)
                skill: 'Навык',
                skillClear: 'Убрать навык',
                generate: 'Создать',
                sendHint: 'Enter — отправить',
                genAgent: 'Агент',
                genAgentHint: 'ИИ соберёт план и подберёт модель',
                genDirect: 'Напрямую',
                genDirectHint: 'Без агента — сразу в выбранную модель',
                aspect: 'Формат',
                upTo: 'до',
                pickRatio: 'Формат картинки',
                ratioAuto: 'Авто',
                ratioAutoHint: 'AI выберет под промпт',
                noPreset: 'Без пресета',
                refUploadError: 'Не удалось загрузить — нажмите ×, попробуйте файл меньше 32 МБ',
                attachRef: 'Прикрепить референс',
                aiQueued: 'Пишите дальше — AI ответит по очереди',
                aiPlaceholder: 'Спроси AI: что нарисовать?',
                sending: 'Отправляю...',
                placeholder: 'Опишите картинку...',
                voiceStart: 'Голосовой ввод',
                voiceStop: 'Остановить и распознать',
                voiceTranscribing: 'Распознаю…',
                voiceErrDenied: 'Разреши доступ к микрофону в настройках браузера',
                voiceErrNoMic: 'Микрофон недоступен на этом устройстве',
                voiceErrUnavailable: 'Голосовой ввод временно недоступен',
                voiceErrFailed: 'Не удалось распознать — попробуй ещё раз',
                errOutOfCredits: 'Закончились бесплатные генерации',
                errFailed: 'Не получилось отправить',
                errPromptTooLong: 'Промпт слишком длинный — сократи (до 5000 символов)',
                jumpToBottom: 'Вниз',
                errTier: 'AI-режим — для Tier-20 подписки',
                errAiDown: 'AI временно недоступен — попробуй позже',
                errAiFailed: 'Не получилось получить ответ',
                pickPreset: 'Выбрать пресет',
                noPresetTitle: 'Без брендбука',
                noPresetSub: 'модель и стиль выбираешь вручную при каждом запросе',
                noPresets: 'Создай первый пресет в Настройках',
                managePresets: 'Управлять пресетами',
                useFromPreset: 'Использовать из пресета',
                pickModel: 'Выбрать модель',
                moreModels: 'Ещё',
                lessModels: 'Свернуть',
                quality: 'Качество',
                pickQuality: 'Качество / разрешение',
                qualityHint: 'По умолчанию — максимум для выбранной модели',
                today: 'Сегодня',
                yesterday: 'Вчера',
                genServiceDown: '⚠️ Сервис временно недоступен. Попробуй через пару минут.',
                genProviderBusy: '😕 Провайдер сейчас отбивает запросы — перегрузка на его стороне. Кредит возвращён, попробуй ещё раз через минуту.',
                genRejected: '⚠️ Контент нарушает правила (NSFW / копирайт / реальные люди). Попробуй переформулировать.',
                genFailed: '⚠️ Не получилось сгенерировать. Попробуй ещё раз.',
            },
            history: {
                title: 'История',
                empty: 'Пока пусто. Напиши /generate боту.',
                today: 'Сегодня',
                yesterday: 'Вчера',
                thisWeek: 'На этой неделе',
                searchPlaceholder: 'Поиск по промтам',
                loadMore: 'Показать ещё',
                loadingMore: 'Загружаю…',
                noPreset: 'Без пресета',
                copyPrompt: 'Скопировать',
                copied: 'Скопировано',
                allProjects: 'Все',
                assignProject: 'В проект',
                noProject: 'Без проекта',
                newProject: 'Новый проект',
                newProjectName: 'Название проекта',
                deleteProject: 'Удалить проект «{{name}}»?',
                action: {
                    open: 'Открыть',
                    copyPrompt: 'Скопировать промпт',
                    toProject: 'В проект',
                    toPreset: 'В пресет',
                    download: 'Скачать PNG',
                    delete: 'Удалить',
                    deleteConfirm: 'Удалить эту генерацию?',
                    back: 'Назад',
                    cancel: 'Отмена',
                },
                status_done: '✅',
                status_error: '⚠️',
                status_running: '⏳',
                status_queued: '⏱',
            },
            styles: {
                title: 'Мои стили',
                empty: 'Стилей пока нет. Создай через /assistant.',
                default: 'По умолчанию',
                set_default: 'Сделать дефолтным',
                delete: 'Удалить',
                tier20_only: 'Доступно на тарифе $50',
                create: 'Создать свой стиль',
                cat: {
                    all: 'Все',
                    photo: 'Фото',
                    art: 'Арт',
                    graph: 'Графика',
                    threeD: '3D',
                    fav: 'Избранное',
                },
            },
            settings: {
                title: 'Настройки',
                language: 'Язык',
                ru: 'Русский',
                en: 'English',
                dark: 'Тёмная тема',
                tariff: 'Тариф',
                guest: 'Гость',
                invite: 'Пригласить друга',
                sections: 'Разделы',
                invited: 'приглашено',
                converted: 'оплатили',
                proDays: 'дней Pro',
                inviteHint: '🎁 Друг получает +{{gens}} бесплатных генераций сразу. Когда друг оплачивает подписку — тебе {{days}} дней Pro.',
                shareTg: 'Поделиться в TG',
                copyLink: 'Копировать',
                copied: '✓ скопировано',
                misc: 'Прочее',
                myPresets: 'Мои пресеты',
                create: 'Создать',
                noPresets: 'Создай первый пресет',
                mainBadge: 'основной',
                newPresetName: 'Новый пресет',
                presetName: 'Название пресета',
                icon: 'Иконка',
                model: 'Модель',
                style: 'Стиль',
                stylePlaceholder: 'например: cinematic lighting, film grain, 35mm',
                ratio: 'Соотношение',
                ratioAuto: 'Авто',
                ratioAutoHint: 'Пусть AI выберет под промпт',
                quality: 'Качество',
                qualityDefault: 'Стандарт',
                modelPicksAspect: '(выбирает модель)',
                autoEnhance: 'Улучшать промт',
                autoEnhanceDesc: 'AI дополнит запрос деталями',
                makeDefault: 'Сделать основным',
                deletePreset: 'Удалить пресет',
                creditsLeftSuffix: 'осталось',
                expiresUntil: 'до {{date}}',
                logout: 'Выйти из аккаунта',
                logoutConfirm: 'Выйти из аккаунта?',
                account: 'Аккаунт и вход',
            },
            account: {
                verified: '✓ подтверждён',
                verify: 'подтвердить',
                verifySent: 'Письмо отправлено',
                verifyErr: 'Не удалось отправить письмо',
                linked: 'привязан ✓',
                link: 'привязать',
                googleLinked: 'Google привязан',
                googleLinkErr: 'Не удалось привязать Google',
                password: 'Пароль',
                setPassword: 'задать пароль',
                changePassword: 'сменить пароль',
                newPassword: 'новый пароль',
                save: 'сохранить',
                passwordSaved: 'Пароль сохранён',
                passwordErr: 'Не удалось сохранить пароль',
                passwordTooShort: 'Пароль слишком короткий (мин. 6 символов)',
                sendCode: 'прислать код в TG',
                codeFromTg: 'код из TG',
                confirm: 'подтвердить',
                phoneNotFound: 'Номер не найден в боте — сперва напишите боту /start',
                wrongCode: 'Неверный код',
            },
            support: {
                title: 'Тех. поддержка',
                subtitle: 'Опишите вопрос — ответим в течение дня',
                placeholder: 'Опишите вопрос…',
                sendError: 'Не удалось отправить. Попробуйте ещё раз.',
                empty: 'Напишите ваш вопрос — оператор ответит в чате. Если опишете проблему подробно (что не работает, какое действие пытались сделать), ответим быстрее.',
            },
            tariff: {
                title: 'Выбери тариф',
                close: 'Закрыть',
                back: 'Назад к тарифам',
                payTitle: 'Оплата',
                month: 'Месяц',
                year: 'Год',
                perMonth: '/мес',
                perYear: '/год',
                save: 'Экономия {{amount}}',
                disabled: 'Оплата сейчас отключена. Напиши в саппорт — активируем вручную.',
                demoDisabled: 'Онлайн-оплата скоро будет доступна.',
                creating: 'Создаём платёж…',
                buy: 'Купить {{name}}',
                noPayUrl: 'Не получили ссылку на оплату. Попробуй позже.',
                payError: 'Не удалось создать платёж',
                legal: 'Оплата картой · Visa / MasterCard / МИР / СБП · Чек по 54-ФЗ.',
                light: { highlight: 'Популярный', f1: 'Безлимит генераций', f2: '2 параллельно', f3: 'Все image-модели', f4: '30-day money-back', video: '25 видео-кредитов в месяц' },
                pro: { highlight: 'Максимум', f1: 'Безлимит + видео', f2: '4 параллельно', f3: 'Sora / Veo / Kling', f4: 'AI-SMMщик: контент-план и автопостинг', video: '75 видео-кредитов + 100 AI-кредитов в месяц' },
            },
            payResult: {
                okTitle: 'Оплата прошла!',
                failTitle: 'Оплата не прошла',
                okBody1: 'Спасибо! Подписка активируется автоматически — обычно за 10–30 секунд. Откроется в боте ',
                okBody2: ' или на этом сайте.',
                failBody1: 'Платёж не был завершён или отклонён банком. Деньги не списаны. Можно попробовать ещё раз или написать в ',
                support: 'поддержку',
                ok: 'Понятно',
                close: 'Закрыть',
            },
            verifyEmail: {
                text1: 'Подтверди email ',
                text2: ' — мы отправили письмо со ссылкой.',
                sent: 'Отправлено ✓',
                resend: 'Отправить ещё раз',
            },
            library: {
                hubTitle: '📚 Библиотека',
                title: 'Библиотека',
                sectionPresets: 'Пресеты',
                sectionPersonas: 'Персонажи',
                sectionStoryboards: 'Сториборды',
                sectionLocations: 'Локации',
                sectionProps: 'Реквизит',
                add: 'Добавить',
                save: 'Сохранить',
                saving: 'Сохраняю…',
                name: 'Имя',
                description: 'Описание',
                refUrl: 'URL фото-референса (опц.)',
                noRef: 'нет фото',
                confirmDelete: 'Удалить?',
                newTitle: 'Новая {{kind}}',
                kindLocation: 'локация',
                kindProp: 'предмет',
                placeholderLocationName: 'мой бар',
                placeholderPropName: 'моя кружка',
                placeholderLocationDesc: 'Спик-изи бар, тёплый янтарный свет, медные лампы, дубовая стойка…',
                placeholderPropDesc: 'Хрустальный олд-фэшнд бокал с гранями…',
                subLocations: 'Места и интерьеры. Юзер скажет «в моём баре» — ассистент сам подхватит ref.',
                subProps: 'Объекты, продукты, реквизит. Юзер скажет «с моей кружкой» — ассистент сам найдёт.',
                emptyLocations: 'Нет локаций. Добавь первую — потом ассистент будет знать как выглядит «твой бар».',
                emptyProps: 'Нет реквизита. Добавь первый — потом ассистент будет знать как выглядит «твоя кружка».',
            },
            personas: {
                title: 'Персонажи',
                add: 'Добавить',
                newTitle: 'Новый персонаж',
                name: 'Имя',
                namePlaceholder: 'Иван',
                description: 'Описание (помогает ИИ)',
                descriptionPlaceholder: 'Возраст, типаж, привычки, что-то важное про образ…',
                linkPack: 'Привязать storyboard pack (опц.)',
                noPack: '— не привязывать —',
                packOption: 'Pack #{{id}} · {{mode}} · {{count}} кадров · {{date}}',
                save: 'Сохранить',
                saving: 'Сохраняю…',
                subtitle: 'Имена + лица. ИИ-ассистент сам подхватит face-ref когда ты упомянешь имя («сделай Ивана в баре»).',
                empty: 'Пока ни одного. Создай первого — потом ассистент будет знать как он выглядит.',
                noFace: 'нет фото',
                confirmDelete: 'Удалить персонажа?',
            },
            storyboards: {
                title: 'Storyboards',
                subtitle: 'Твоя библиотека character sheets, product 360 и сюжетов. Тапни любой кадр чтобы использовать его как лицо/референс для новой ген.',
                queuedHint: 'Ген запущена',
                queuedHintExtra: 'Результат придёт в чат бота через ~30-60с.',
                useCardTitle: 'Использовать как референс',
                useCardHint: 'Опиши новую сцену — лицо/образ останутся как на карточке.',
                useCardPh: 'Например: «в баре с коктейлем, тёплый янтарный свет»',
                queuing: 'Ставлю в очередь…',
                generate: 'Запустить ген',
                empty: 'Пока нет ни одного storyboard\'a. Нажми «🎬 Storyboard» под любой готовой картинкой в боте или попроси ассистента «сделай мне storyboard 9 кадров…».',
                framesSuffix: 'кадров',
                mode: {
                    character_pack: 'Character pack',
                    product_360: 'Product 360',
                    scene_story: 'Scene story',
                    full_photoshoot: 'Полная фотосессия',
                    full_story: 'Сюжетный день',
                    auto: 'Storyboard',
                },
            },
            errors: {
                auth: 'Не удалось авторизоваться. Открой кабинет через бота.',
                load: 'Ошибка загрузки',
            },
        },
    },
    en: {
        translation: {
            header: { botSub: 'bot' },
            common: {
                cancel: 'Cancel',
                close: 'Close',
                delete: 'Delete',
                loading: 'Loading…',
                save: 'Save',
                saving: 'Saving…',
            },
            preset: {
                makeFromPhoto: 'Make preset',
                makeFromPhotoTitle: 'Make a preset from this frame',
                drafting: 'AI is extracting the concept…',
                draftUsedVision: 'AI used both the image and the prompt',
                draftTierGate: 'Available on the Pro plan',
                draftQuota: 'Daily limit reached, try tomorrow',
                draftError: 'Could not build the concept',
                concept: 'Concept (style prompt)',
                conceptPh: 'frame style without the specific product',
                create: 'Create preset',
                created: 'Preset created',
                createError: 'Could not create preset',
                nameTaken: 'A preset with this name already exists',
            },
            batch: {
                title: 'Batch processing',
                ctaHint: 'up to 10 frames by preset',
                hint: 'Each photo/subject = its OWN separate generation by the preset prompt (not one frame with all refs). Up to 10 at a time — run as a batch.',
                needPreset: 'Pick a preset first — the batch generates by its prompt',
                needRefs: 'Attach photos — each becomes its own frame',
                switchHint: 'Batch: as many photos as you attach = that many frames by the preset',
                composerHint: '📦 Batch: each photo = its own frame by preset “{{name}}”. Photos now: {{n}}',
                modePhoto: 'Photo refs',
                modeText: 'List of subjects',
                refsLabel: 'Photos',
                photoNote: 'Each photo is restyled with the preset concept — the preset model must support references.',
                subjectsLabel: 'Subjects — one per line',
                run: 'Create {{n}} frames',
                started: 'Frames started: {{n}}',
                uploadError: 'Could not upload photo',
                noCredits: 'Not enough credits',
                error: 'Could not start the batch',
            },
            home: {
                title: 'Scenix',
                plan_trial: 'Plan: Trial',
                plan_tier10: 'Plan: Light',
                plan_tier20: 'Plan: Pro',
                balance: 'Free credits left: {{remaining}}/10',
                total: 'Total generated: {{count}}',
                upgrade: 'Upgrade plan',
            },
            tabs: {
                chat: 'Chat',
                home: 'Home',
                history: 'History',
                ideas: 'Ideas',
                library: 'Library',
                marketing: 'SMM',
                profile: 'Profile',
                styles: 'Styles',
                settings: 'Settings',
                studio: 'Studio',
                avatars: 'Avatars',
                skills: 'Skills',
            },
            mode: {
                label: 'Mode',
                chat: 'Chat',
                studio: 'Studio',
                studioHint: 'Studio · canvases, AI director (beta)',
            },
            chat: {
                recentTitle: 'Recent generations',
                recentEmpty: 'Your works will appear here',
                tileSize: 'Tile size',
                tilesPerRow: 'Per row',
                batchHint: 'Frames per send: ×2 — Light, ×4 — Pro',
                greeting: 'Hi! Pick a model below, attach a reference (optional) and send a prompt.',
                aiGreeting: "Hi! I'm an AI assistant. Describe what you want — I'll build the prompt and pick the model myself.",
                generating: 'Generating',
                copy: 'Copy',
                open: 'Open',
                repeat: 'Repeat',
                download: 'Download',
                aiThinking: 'AI is thinking...',
                aiQueueSuffix: 'in queue',
                aiToggle: 'AI assistant',
                aiModelByItself: 'AI picks the model',
                // Composer bar (same layout as Home)
                skill: 'Skill',
                skillClear: 'Remove skill',
                generate: 'Create',
                sendHint: 'Enter to send',
                genAgent: 'Agent',
                genAgentHint: 'AI plans the steps and picks a model',
                genDirect: 'Direct',
                genDirectHint: 'No agent — straight to the selected model',
                aspect: 'Aspect',
                upTo: 'up to',
                pickRatio: 'Image format',
                ratioAuto: 'Auto',
                ratioAutoHint: 'AI will pick based on the prompt',
                noPreset: 'No preset',
                refUploadError: 'Upload failed — tap ×, try a file under 32 MB',
                attachRef: 'Attach a reference',
                aiQueued: 'Keep typing — AI will reply in turn',
                aiPlaceholder: 'Ask AI: what to draw?',
                sending: 'Sending...',
                placeholder: 'Describe the image...',
                voiceStart: 'Voice input',
                voiceStop: 'Stop and transcribe',
                voiceTranscribing: 'Transcribing…',
                voiceErrDenied: 'Allow microphone access in your browser settings',
                voiceErrNoMic: 'Microphone is not available on this device',
                voiceErrUnavailable: 'Voice input is temporarily unavailable',
                voiceErrFailed: 'Could not transcribe — please try again',
                errOutOfCredits: 'Out of free generations',
                errFailed: 'Failed to send',
                errPromptTooLong: 'Prompt is too long — shorten it (up to 5000 characters)',
                jumpToBottom: 'To bottom',
                errTier: 'AI mode — for Tier-20 subscription',
                errAiDown: 'AI is temporarily unavailable — try again later',
                errAiFailed: 'Failed to get a response',
                pickPreset: 'Pick a preset',
                noPresetTitle: 'No brand book',
                noPresetSub: 'pick model and style manually for each request',
                noPresets: 'Create your first preset in Settings',
                managePresets: 'Manage presets',
                useFromPreset: 'Use from preset',
                pickModel: 'Pick a model',
                moreModels: 'More',
                lessModels: 'Collapse',
                quality: 'Quality',
                pickQuality: 'Quality / resolution',
                qualityHint: 'Defaults to the maximum for the selected model',
                today: 'Today',
                yesterday: 'Yesterday',
                genServiceDown: '⚠️ Service is temporarily unavailable. Try again in a couple of minutes.',
                genProviderBusy: "😕 The provider is rejecting requests right now — it's overloaded on their side. Your credit is refunded, try again in a minute.",
                genRejected: '⚠️ Content violates the policy (NSFW / copyright / real people). Try rephrasing.',
                genFailed: '⚠️ Could not generate. Please try again.',
            },
            history: {
                title: 'History',
                empty: 'Nothing yet. Send /generate to the bot.',
                today: 'Today',
                yesterday: 'Yesterday',
                thisWeek: 'This week',
                searchPlaceholder: 'Search prompts',
                loadMore: 'Show more',
                loadingMore: 'Loading…',
                noPreset: 'No preset',
                copyPrompt: 'Copy',
                copied: 'Copied',
                allProjects: 'All',
                assignProject: 'To project',
                noProject: 'No project',
                newProject: 'New project',
                newProjectName: 'Project name',
                deleteProject: 'Delete project "{{name}}"?',
                action: {
                    open: 'Open',
                    copyPrompt: 'Copy prompt',
                    toProject: 'Move to project',
                    toPreset: 'To preset',
                    download: 'Download PNG',
                    delete: 'Delete',
                    deleteConfirm: 'Delete this generation?',
                    back: 'Back',
                    cancel: 'Cancel',
                },
                status_done: '✅',
                status_error: '⚠️',
                status_running: '⏳',
                status_queued: '⏱',
            },
            styles: {
                title: 'My styles',
                empty: 'No styles yet. Create one via /assistant.',
                default: 'Default',
                set_default: 'Set default',
                delete: 'Delete',
                tier20_only: 'Available on $50 plan',
                create: 'Create your style',
                cat: {
                    all: 'All',
                    photo: 'Photo',
                    art: 'Art',
                    graph: 'Graphics',
                    threeD: '3D',
                    fav: 'Favorites',
                },
            },
            settings: {
                title: 'Settings',
                language: 'Language',
                ru: 'Russian',
                en: 'English',
                dark: 'Dark theme',
                tariff: 'Plan',
                guest: 'Guest',
                invite: 'Invite a friend',
                sections: 'Sections',
                invited: 'invited',
                converted: 'paid',
                proDays: 'Pro days',
                inviteHint: '🎁 Your friend gets +{{gens}} free generations instantly. When they pay for a subscription — you get {{days}} Pro days.',
                shareTg: 'Share via TG',
                copyLink: 'Copy',
                copied: '✓ copied',
                misc: 'Other',
                myPresets: 'My presets',
                create: 'Create',
                noPresets: 'Create your first preset',
                mainBadge: 'default',
                newPresetName: 'New preset',
                presetName: 'Preset name',
                icon: 'Icon',
                model: 'Model',
                style: 'Style',
                stylePlaceholder: 'e.g.: cinematic lighting, film grain, 35mm',
                ratio: 'Aspect ratio',
                ratioAuto: 'Auto',
                ratioAutoHint: 'Let AI pick based on prompt',
                quality: 'Quality',
                qualityDefault: 'Standard',
                modelPicksAspect: '(model decides)',
                autoEnhance: 'Enhance prompt',
                autoEnhanceDesc: 'AI will enrich your request with details',
                makeDefault: 'Set as default',
                deletePreset: 'Delete preset',
                creditsLeftSuffix: 'left',
                expiresUntil: 'until {{date}}',
                logout: 'Log out',
                logoutConfirm: 'Log out of your account?',
                account: 'Account & login',
            },
            account: {
                verified: '✓ verified',
                verify: 'verify',
                verifySent: 'Email sent',
                verifyErr: 'Failed to send email',
                linked: 'linked ✓',
                link: 'link',
                googleLinked: 'Google linked',
                googleLinkErr: 'Failed to link Google',
                password: 'Password',
                setPassword: 'set password',
                changePassword: 'change password',
                newPassword: 'new password',
                save: 'save',
                passwordSaved: 'Password saved',
                passwordErr: 'Failed to save password',
                passwordTooShort: 'Password too short (min. 6 characters)',
                sendCode: 'send code to TG',
                codeFromTg: 'code from TG',
                confirm: 'confirm',
                phoneNotFound: 'Phone not found in the bot — message /start to the bot first',
                wrongCode: 'Wrong code',
            },
            support: {
                title: 'Support',
                subtitle: "Describe your question — we'll reply within a day",
                placeholder: 'Describe your question…',
                sendError: 'Failed to send. Please try again.',
                empty: "Write your question — an operator will reply in the chat. The more detail you give (what isn't working, what action you tried), the faster we can help.",
            },
            tariff: {
                title: 'Choose a plan',
                close: 'Close',
                back: 'Back to plans',
                payTitle: 'Payment',
                month: 'Month',
                year: 'Year',
                perMonth: '/mo',
                perYear: '/yr',
                save: 'Save {{amount}}',
                disabled: "Payments are off right now. Message support — we’ll activate it manually.",
                demoDisabled: 'Online payment is coming soon.',
                creating: 'Creating payment…',
                buy: 'Buy {{name}}',
                noPayUrl: 'Could not get a payment link. Try again later.',
                payError: 'Failed to create payment',
                legal: 'Secure card payment · Visa / MasterCard · processed by Robokassa.',
                light: { highlight: 'Popular', f1: 'Unlimited generations', f2: '2 in parallel', f3: 'All image models', f4: '30-day money-back', video: '25 video credits / month' },
                pro: { highlight: 'Maximum', f1: 'Unlimited + video', f2: '4 in parallel', f3: 'Sora / Veo / Kling', f4: 'AI SMM manager: content plan & autoposting', video: '75 video credits + 100 AI credits / month' },
            },
            payResult: {
                okTitle: 'Payment succeeded!',
                failTitle: 'Payment failed',
                okBody1: 'Thank you! Your subscription activates automatically — usually within 10–30 seconds. It will open in the bot ',
                okBody2: ' or on this site.',
                failBody1: 'The payment was not completed or was declined by the bank. No money was charged. You can try again or contact ',
                support: 'support',
                ok: 'Got it',
                close: 'Close',
            },
            verifyEmail: {
                text1: 'Confirm your email ',
                text2: ' — we sent a message with a link.',
                sent: 'Sent ✓',
                resend: 'Send again',
            },
            library: {
                hubTitle: '📚 Library',
                title: 'Library',
                sectionPresets: 'Presets',
                sectionPersonas: 'Characters',
                sectionStoryboards: 'Storyboards',
                sectionLocations: 'Locations',
                sectionProps: 'Props',
                add: 'Add',
                save: 'Save',
                saving: 'Saving…',
                name: 'Name',
                description: 'Description',
                refUrl: 'Reference photo URL (optional)',
                noRef: 'no photo',
                confirmDelete: 'Delete?',
                newTitle: 'New {{kind}}',
                kindLocation: 'location',
                kindProp: 'prop',
                placeholderLocationName: 'my bar',
                placeholderPropName: 'my mug',
                placeholderLocationDesc: 'Speak-easy bar, warm amber light, copper lamps, oak counter…',
                placeholderPropDesc: 'Crystal old-fashioned glass with facets…',
                subLocations: 'Places and interiors. Say "in my bar" and the assistant picks the ref automatically.',
                subProps: 'Objects, products, props. Say "with my mug" and the assistant finds it.',
                emptyLocations: 'No locations yet. Add the first one — the assistant will know how "your bar" looks.',
                emptyProps: 'No props yet. Add the first one — the assistant will know how "your mug" looks.',
            },
            personas: {
                title: 'Characters',
                add: 'Add',
                newTitle: 'New character',
                name: 'Name',
                namePlaceholder: 'John',
                description: 'Description (helps AI)',
                descriptionPlaceholder: 'Age, type, habits, anything important about the look…',
                linkPack: 'Link a storyboard pack (optional)',
                noPack: '— do not link —',
                packOption: 'Pack #{{id}} · {{mode}} · {{count}} frames · {{date}}',
                save: 'Save',
                saving: 'Saving…',
                subtitle: 'Names + faces. AI assistant picks up the face-ref automatically when you mention the name ("make John in the bar").',
                empty: 'None yet. Create your first one — then the assistant will know what they look like.',
                noFace: 'no photo',
                confirmDelete: 'Delete this character?',
            },
            storyboards: {
                title: 'Storyboards',
                subtitle: 'Your library of character sheets, product 360 and stories. Tap any frame to use it as face/reference for a new generation.',
                queuedHint: 'Generation queued',
                queuedHintExtra: 'Result will arrive in the bot chat in ~30-60s.',
                useCardTitle: 'Use as reference',
                useCardHint: 'Describe the new scene — face/style will stay as in the card.',
                useCardPh: 'E.g.: "in a bar with a cocktail, warm amber light"',
                queuing: 'Queueing…',
                generate: 'Run generation',
                empty: 'No storyboards yet. Tap "🎬 Storyboard" under any ready image in the bot or ask the assistant "make me a storyboard of 9 frames…".',
                framesSuffix: 'frames',
                mode: {
                    character_pack: 'Character pack',
                    product_360: 'Product 360',
                    scene_story: 'Scene story',
                    full_photoshoot: 'Full photoshoot',
                    full_story: 'Story day',
                    auto: 'Storyboard',
                },
            },
            errors: {
                auth: 'Authentication failed. Open the app via the bot.',
                load: 'Loading error',
            },
        },
    },
};
function detectInitialLang() {
    try {
        // Явный выбор пользователя (общий ключ с лендингом — pages/Landing/lang.ts),
        // чтобы Mini App и публичный сайт не расходились по языку.
        const saved = typeof localStorage !== 'undefined' ? localStorage.getItem('pm:lang') : null;
        if (saved === 'ru' || saved === 'en')
            return saved;
        const tg = window.Telegram?.WebApp;
        const tgLang = tg?.initDataUnsafe?.user?.language_code;
        if (tgLang)
            return tgLang.toLowerCase().startsWith('ru') ? 'ru' : 'en';
        const navLang = typeof navigator !== 'undefined' ? (navigator.language || '') : '';
        if (navLang)
            return navLang.toLowerCase().startsWith('ru') ? 'ru' : 'en';
    }
    catch {
        /* ignore */
    }
    return 'ru';
}
/** Единая точка смены языка: меняет react-i18next И пишет общий ключ `pm:lang`,
 *  чтобы публичный лендинг (своя i18n-система) подхватил тот же выбор. */
export function setAppLang(lang) {
    i18n.changeLanguage(lang);
    try {
        localStorage.setItem('pm:lang', lang);
    }
    catch { /* ignore */ }
}
i18n.use(initReactI18next).init({
    resources,
    lng: detectInitialLang(),
    fallbackLng: 'ru',
    interpolation: { escapeValue: false },
});
export default i18n;
